import ClientProductWithHierarchy from "@/models/Agents/ProductWithHierarchy";

export const differentValues = (
  entities: ClientProductWithHierarchy[],
  property: keyof ClientProductWithHierarchy | null = null,
  func: Function | null = null,
  agentType: string | null = null
): boolean => {
  let values: Array<string | number> = [];
  if (func && agentType)
    values = entities.map((entity) => func(agentType, entity));
  else if (func) values = entities.map((entity) => func(entity));
  else if (property) values = entities.map((entity) => entity[property]);

  return !(new Set(values).size === 1);
};
